<div>
  <div class="container" id="login">
    <div class="row">
      <div class="col-md-12">
        <h1>DAR Admin Log In:</h1>
        <p>Enter your Username and Password below; then click on the Submit button to continue.</p>
      </div>
    </div>
    <div *ngIf="message" role="alert" class="formError text-danger" aria-live="assertive">
      <p>{{message}}</p>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="row mb-2">
        <div class="col-md-12">
          <div>All fields are required.</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <div class="form-group">
            <label for="dealerID">Username</label>
            <input id="dealerID" type="text" formControlName="username"
                   class="form-control required" aria-required="true" [ngClass]="{'is-invalid': hasError('username')}"
                   aria-label="dealer id" [attr.aria-invalid]="hasError('username')" required />
            <div *ngIf="hasError('username')" role="alert" class="formError text-danger" aria-live="assertive">
              <div *ngIf="hasError('username', 'required')">Required</div>
              <div *ngIf="hasError('username', 'validUsername')">Invalid</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="form-group">
            <label for="dealerPassword">Password</label>
            <input id="dealerPassword" type="password" formControlName="password"
                   class="form-control required"  aria-required="true" [ngClass]="{'is-invalid': hasError('password')}"
                   aria-label="dealer password" [attr.aria-invalid]="hasError('password')" required />
            <div *ngIf="hasError('password')" role="alert" class="formError text-danger" aria-live="assertive">
              <div *ngIf="hasError('password', 'required')">Required</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button type="submit" [disabled]="loginForm.touched && !loginForm.valid"
                  class="btn btn-primary btn mb-3" id="admin-login-submit-button"><i class="fas fa-sign-in-alt"></i> Log In</button>
        </div>
      </div>
    </form>
  </div>
</div>
